import { ResourceProps } from "@refinedev/core";
import { TrophyOutlined } from "@ant-design/icons";

export const awardsResource: ResourceProps = {
  name: "awards",
  meta: {
    icon: <TrophyOutlined />,
    label: "Награды",
  },
  list: "/awards",
  create: "/awards/create",
  show: "/awards/:id",
};
